import { render, staticRenderFns } from "./password.vue?vue&type=template&id=fc0400fa&scoped=true&"
import script from "./password.vue?vue&type=script&lang=js&"
export * from "./password.vue?vue&type=script&lang=js&"
import style0 from "./password.vue?vue&type=style&index=0&id=fc0400fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0400fa",
  null
  
)

export default component.exports